import React, { useEffect } from 'react';
import { Container, Form, Col, Row } from 'react-bootstrap';
import PropTypes from 'prop-types';
import { useForm } from 'react-hook-form/dist/react-hook-form.ie11';
import { MultiSelectInput, TextInput, SelectInput } from '../../../Helpers/Inputs';
import BackNextButton from '../../../Common/BackNextButton';
import { BenefitType, DeathBenefitOptions, ImportantOptions, ObjectiveOptions, PolicyOwnerOptions, PremiumDurationOptions, YesNoOptions } from '../SubComponents/SelectOptions';
import { NumberFormatDollars } from '../../../Helpers/Formatters';
import { object, string } from 'yup';
import { FormLabel } from '@material-ui/core';

export default function ClientPreferences(props) {
  const { register, errors, handleSubmit, setValue, triggerValidation } = useForm({
    validationSchema: ClientPreferences.ValidationSchema,
    mode: 'onBlur',
    reValidateMode: 'onBlur',
  });

  const handleValueChange = (field, value) => {
    setValue(field, value);
    props.onFieldChange(field, value);
    triggerValidation(field);
  };

  useEffect(() => {
    register({ name: 'clientObjective' });
    setValue('clientObjective', props.formState.clientObjective);

    register({ name: 'existingInsurance' });
    setValue('existingInsurance', props.formState.existingInsurance);

    register({ name: 'howLongDeathBenefit' });
    setValue('howLongDeathBenefit', props.formState.howLongDeathBenefit);

    register({ name: 'deathBenefitType' });
    setValue('deathBenefitType', props.formState.deathBenefitType);

    register({ name: 'policyOwner' });
    setValue('policyOwner', props.formState.policyOwner);

    register({ name: 'policyCoverInCaseLongTermCare' });
    setValue('policyCoverInCaseLongTermCare', props.formState.policyCoverInCaseLongTermCare);

    register({ name: 'premiumDuration' });
    setValue('premiumDuration', props.formState.premiumDuration);

    register({ name: 'changeUnderlyingInvestments' });
    setValue('changeUnderlyingInvestments', props.formState.changeUnderlyingInvestments);

    register({ name: 'alterDeathBenefits' });
    setValue('alterDeathBenefits', props.formState.alterDeathBenefits);

    register({ name: 'alterPremiumsUpOrDownOrSkip' });
    setValue('alterPremiumsUpOrDownOrSkip', props.formState.alterPremiumsUpOrDownOrSkip);

    register({ name: 'accessSignificantCashValues' });
    setValue('accessSignificantCashValues', props.formState.accessSignificantCashValues);

    register({ name: 'maximizeCashValueGrowth' });
    setValue('maximizeCashValueGrowth', props.formState.maximizeCashValueGrowth);

    register({ name: 'illustrateDistributions' });
    setValue('illustrateDistributions', props.formState.illustrateDistributions);

    register({ name: 'additionalComments' });
    setValue('additionalComments', props.formState.additionalComments);

    register({ name: 'existingInsuranceAmount' });
    setValue('existingInsuranceAmount', props.formState.existingInsuranceAmount);

    register({ name: 'usePolicyToFundNewPolicy' });
    setValue('usePolicyToFundNewPolicy', props.formState.usePolicyToFundNewPolicy);

    register({ name: 'howLongRequireDeathBenefitOther' });
    setValue('howLongRequireDeathBenefitOther', props.formState.howLongRequireDeathBenefitOther);

    register({ name: 'ownerTypeOther' });
    setValue('ownerTypeOther', props.formState.ownerTypeOther);

    register({ name: 'illustrateDistributionsDetails' });
    setValue('illustrateDistributionsDetails', props.formState.illustrateDistributionsDetails);

  }, [register])

  return (
    <Container fluid className='quote-class border-class'>
      <form className="quoteDeatilForm" onSubmit={handleSubmit(props.onNext)}>
        <Row className="justify-content-center pt-4">
          <Col lg={4} className="radio-grp">
            <h4 className="text-center mt-2 mb-3"><b>Client Preferences</b></h4>
            <Form.Group>
              <p className='mb-1'><b>Check all that apply.</b></p>
              <MultiSelectInput
                name="clientObjective"
                id="clientObjective"
                value={props.formState.clientObjective ? props.formState.clientObjective : []}
                onChange={(e) => handleValueChange('clientObjective', e.target.value)}
                label="What is the overall objective of the client?"
                selectOptions={ObjectiveOptions()}
                errors={errors.clientObjective}
                inputRef={register}
              />
            </Form.Group>

            <Form.Group className='mt-4'>
              <FormLabel>Does your client currently have existing Life Insurance coverage?</FormLabel>
              <SelectInput
                name="existingInsurance"
                id="existingInsurance"
                value={props.formState.existingInsurance}
                onChange={(e) => handleValueChange('existingInsurance', e.target.value)}
                label=""
                selectOptions={YesNoOptions(true)}
                errors={errors.existingInsurance}
                inputRef={register}
                className='select-input-center-option'
                hideEmptyOption
              />
            </Form.Group>

            {props.formState.existingInsurance === "Yes" &&
              <React.Fragment>
                <Form.Group className='mt-4'>
                  <TextInput
                    name="existingInsuranceAmount"
                    id="existingInsuranceAmount"
                    label="If yes, how much?"
                    value={props.formState.existingInsuranceAmount}
                    errors={errors && errors.existingInsuranceAmount}
                    inputRef={register}
                    onChange={(e) => handleValueChange('existingInsuranceAmount', e.target.value)}
                    InputProps={{
                      inputComponent: NumberFormatDollars,
                    }}
                  />
                </Form.Group>

                <Form.Group className='mt-4'>
                  <FormLabel>Would you like to use this policy to help fund the new one?</FormLabel>
                  <SelectInput
                    name="usePolicyToFundNewPolicy"
                    id="usePolicyToFundNewPolicy"
                    value={props.formState.usePolicyToFundNewPolicy}
                    onChange={(e) => handleValueChange('usePolicyToFundNewPolicy', e.target.value)}
                    label=""
                    selectOptions={YesNoOptions()}
                    errors={errors.usePolicyToFundNewPolicy}
                    inputRef={register}
                    hideEmptyOption
                    className='select-input-center-option'
                  />
                </Form.Group>
              </React.Fragment>
            }

            <Form.Group className='mt-4'>
              <FormLabel>How long will your client require the death benefits?</FormLabel>
              <SelectInput
                name="howLongDeathBenefit"
                id="howLongDeathBenefit"
                value={props.formState.howLongDeathBenefit}
                onChange={(e) => handleValueChange('howLongDeathBenefit', e.target.value)}
                label=""
                selectOptions={DeathBenefitOptions()}
                errors={errors.howLongDeathBenefit}
                inputRef={register}
                hideEmptyOption
                className='select-input-center-option'
              />
            </Form.Group>

            {props.formState.howLongDeathBenefit === "Other" &&
              <Form.Group className='mt-4'>
                <TextInput
                  name="howLongRequireDeathBenefitOther"
                  id="howLongRequireDeathBenefitOther"
                  label="If other, please specify:"
                  value={props.formState.howLongRequireDeathBenefitOther}
                  errors={errors && errors.howLongRequireDeathBenefitOther}
                  inputRef={register}
                  onChange={(e) => handleValueChange('howLongRequireDeathBenefitOther', e.target.value)}
                />
              </Form.Group>
            }

            <Form.Group className='mt-4'>
              <FormLabel>What type of death benefit would your client prefer?</FormLabel>
              <SelectInput
                name="deathBenefitType"
                id="deathBenefitType"
                value={props.formState.deathBenefitType}
                onChange={(e) => handleValueChange('deathBenefitType', e.target.value)}
                label=""
                selectOptions={BenefitType()}
                errors={errors.deathBenefitType}
                inputRef={register}
                hideEmptyOption
                className='select-input-center-option'
              />
            </Form.Group>

            <Form.Group className='mt-4'>
              <FormLabel>Who will own this policy?</FormLabel>
              <SelectInput
                name="policyOwner"
                id="policyOwner"
                value={props.formState.policyOwner}
                onChange={(e) => handleValueChange('policyOwner', e.target.value)}
                label=""
                selectOptions={PolicyOwnerOptions()}
                errors={errors.policyOwner}
                inputRef={register}
                hideEmptyOption
                className='select-input-center-option'
              />
            </Form.Group>
            {props.formState.policyOwner === "Other" &&
              <Form.Group className='mt-4'>
                <TextInput
                  name="ownerTypeOther"
                  id="ownerTypeOther"
                  label="If other, please specify:"
                  value={props.formState.ownerTypeOther}
                  errors={errors && errors.ownerTypeOther}
                  inputRef={register}
                  onChange={(e) => handleValueChange('ownerTypeOther', e.target.value)}
                />
              </Form.Group>
            }

            <Form.Group className='mt-4'>
              <FormLabel>How important is the ability to have the policy to cover in case of a long-term care event?</FormLabel>
              <SelectInput
                name="policyCoverInCaseLongTermCare"
                id="policyCoverInCaseLongTermCare"
                value={props.formState.policyCoverInCaseLongTermCare}
                onChange={(e) => handleValueChange('policyCoverInCaseLongTermCare', e.target.value)}
                label=""
                selectOptions={ImportantOptions()}
                errors={errors.policyCoverInCaseLongTermCare}
                inputRef={register}
                hideEmptyOption
                className='select-input-center-option'
              />
            </Form.Group>

            <Form.Group className='mt-4'>
              <FormLabel>Which premium duration does your client prefer?</FormLabel>
              <SelectInput
                name="premiumDuration"
                id="premiumDuration"
                value={props.formState.premiumDuration}
                onChange={(e) => handleValueChange('premiumDuration', e.target.value)}
                label=""
                selectOptions={PremiumDurationOptions()}
                errors={errors.premiumDuration}
                inputRef={register}
                hideEmptyOption
                className='select-input-center-option'
              />
            </Form.Group>

            <Form.Group className='mt-4'>
              <FormLabel>How important is the ability to control and change underlying investments in the contract?</FormLabel>
              <SelectInput
                name="changeUnderlyingInvestments"
                id="changeUnderlyingInvestments"
                value={props.formState.changeUnderlyingInvestments}
                onChange={(e) => handleValueChange('changeUnderlyingInvestments', e.target.value)}
                label=""
                selectOptions={ImportantOptions()}
                errors={errors.changeUnderlyingInvestments}
                inputRef={register}
                hideEmptyOption
                className='select-input-center-option'
              />
            </Form.Group>

            <Form.Group className='mt-4'>
              <FormLabel>How important is it to have flexibility to increase or decrease your policy’s death benefit?</FormLabel>
              <SelectInput
                name="alterDeathBenefits"
                id="alterDeathBenefits"
                value={props.formState.alterDeathBenefits}
                onChange={(e) => handleValueChange('alterDeathBenefits', e.target.value)}
                label=""
                selectOptions={ImportantOptions()}
                errors={errors.alterDeathBenefits}
                inputRef={register}
                hideEmptyOption
                className='select-input-center-option'
              />
            </Form.Group>

            <Form.Group className='mt-4'>
              <FormLabel>How important is the ability to have flexible premium options and/or the ability to skip a premium payment if needed?</FormLabel>
              <SelectInput
                name="alterPremiumsUpOrDownOrSkip"
                id="alterPremiumsUpOrDownOrSkip"
                value={props.formState.alterPremiumsUpOrDownOrSkip}
                onChange={(e) => handleValueChange('alterPremiumsUpOrDownOrSkip', e.target.value)}
                label=""
                selectOptions={ImportantOptions()}
                errors={errors.alterPremiumsUpOrDownOrSkip}
                inputRef={register}
                hideEmptyOption
                className='select-input-center-option'
              />
            </Form.Group>

            <Form.Group className='mt-4'>
              <FormLabel>How important is it to have access to potential tax deferral cash values of the contract at some point in the future?</FormLabel>
              <SelectInput
                name="accessSignificantCashValues"
                id="accessSignificantCashValues"
                value={props.formState.accessSignificantCashValues}
                onChange={(e) => handleValueChange('accessSignificantCashValues', e.target.value)}
                label=""
                selectOptions={ImportantOptions()}
                errors={errors.accessSignificantCashValues}
                inputRef={register}
                hideEmptyOption
                className='select-input-center-option'
              />
            </Form.Group>

            <Form.Group className='mt-4'>
              <FormLabel>How important is it to maximize cash value growth in the policy?</FormLabel>
              <SelectInput
                name="maximizeCashValueGrowth"
                id="maximizeCashValueGrowth"
                value={props.formState.maximizeCashValueGrowth}
                onChange={(e) => handleValueChange('maximizeCashValueGrowth', e.target.value)}
                label=""
                selectOptions={ImportantOptions()}
                errors={errors.maximizeCashValueGrowth}
                inputRef={register}
                hideEmptyOption
                className='select-input-center-option'
              />
            </Form.Group>

            <Form.Group className='mt-4'>
              <FormLabel>Would you like to illustrate distributions from this policy?</FormLabel>
              <SelectInput
                name="illustrateDistributions"
                id="illustrateDistributions"
                value={props.formState.illustrateDistributions}
                onChange={(e) => handleValueChange('illustrateDistributions', e.target.value)}
                label=""
                selectOptions={YesNoOptions()}
                errors={errors.illustrateDistributions}
                inputRef={register}
                hideEmptyOption
                className='select-input-center-option'
              />
            </Form.Group>

            {props.formState.illustrateDistributions === "Yes" &&
              <Form.Group className='mt-4'>
                <TextInput
                  name="illustrateDistributionsDetails"
                  id="illustrateDistributionsDetails"
                  label="If yes, what is desired?"
                  value={props.formState.illustrateDistributionsDetails}
                  errors={errors && errors.illustrateDistributionsDetails}
                  inputRef={register}
                  onChange={(e) => handleValueChange('illustrateDistributionsDetails', e.target.value)}
                />
              </Form.Group>
            }

            <Form.Group className='mt-4'>
              <TextInput
                name="additionalComments"
                id="additionalComments"
                value={props.formState.additionalComments}
                onChange={(e) => handleValueChange('additionalComments', e.target.value)}
                label="Any Additional Comments:"
                errors={errors.additionalComments}
                inputRef={register}
              />
            </Form.Group>
          </Col>
        </Row>
        <BackNextButton onBack={props.onBack} />
      </form>
    </Container>
  );
}

ClientPreferences.propTypes = {
  formState: PropTypes.object.isRequired,
  onNext: PropTypes.func.isRequired,
  onBack: PropTypes.func.isRequired,
  onFieldChange: PropTypes.func.isRequired,
};

ClientPreferences.ValidationSchema = object().shape({
  clientObjective: string().required("This field is required."),
  existingInsurance: string().required("This field is required."),
  existingInsuranceAmount: string().when('existingInsurance', {
    is: (existingInsurance) => existingInsurance === 'Yes',
    then: string().nullable().required('This field is required.'),
    otherwise: string().nullable().notRequired()
  }),
  usePolicyToFundNewPolicy: string().when('existingInsurance', {
    is: (existingInsurance) => existingInsurance === 'Yes',
    then: string().required('This field is required.'),
    otherwise: string().notRequired()
  }),
  howLongDeathBenefit: string().required('This field is required.'),
  howLongRequireDeathBenefitOther: string().when('howLongDeathBenefit', {
    is: (howLongDeathBenefit) => howLongDeathBenefit === 'Other',
    then: string().required('This field is required.').matches(/^[^\s]+(\s+[^\s]+)*$/, 'Invalid data. Remove extra spaces.'),
    otherwise: string().notRequired()
  }),
  deathBenefitType: string().required('This field is required.'),
  policyOwner: string().required('This field is required.'),
  ownerTypeOther: string().when('policyOwner', {
    is: (policyOwner) => policyOwner === 'Other',
    then: string().required('This field is required.').matches(/^[^\s]+(\s+[^\s]+)*$/, 'Invalid data. Remove extra spaces.'),
    otherwise: string().notRequired()
  }),
  policyCoverInCaseLongTermCare: string().notRequired(),
  premiumDuration: string().notRequired(),
  changeUnderlyingInvestments: string().notRequired(),
  alterDeathBenefits: string().notRequired(),
  alterPremiumsUpOrDownOrSkip: string().notRequired(),
  accessSignificantCashValues: string().notRequired(),
  maximizeCashValueGrowth: string().notRequired(),
  illustrateDistributions: string().notRequired(),
  illustrateDistributionsDetails: string().when('illustrateDistributions', {
    is: (illustrateDistributions) => illustrateDistributions === 'Yes',
    then: string().required('This field is required.').matches(/^[^\s]+(\s+[^\s]+)*$/, 'Invalid data. Remove extra spaces.'),
    otherwise: string().notRequired()
  }),
  additionalComments: string().notRequired().matches(/(^$)|^[^\s]+(\s+[^\s]+)*$/,'Invalid data. Remove extra spaces.'),
});

ClientPreferences.DefaultFormState = () => {
  return {
    clientObjective: '',
    existingInsurance: '',
    howLongDeathBenefit: '',
    deathBenefitType: '',
    policyOwner: '',
    policyCoverInCaseLongTermCare: '',
    premiumDuration: '',
    changeUnderlyingInvestments: '',
    alterDeathBenefits: '',
    alterPremiumsUpOrDownOrSkip: '',
    accessSignificantCashValues: '',
    maximizeCashValueGrowth: '',
    illustrateDistributions: '',
    additionalComments: '',
    existingInsuranceAmount: null,
    usePolicyToFundNewPolicy: '',
    howLongRequireDeathBenefitOther: '',
    ownerTypeOther: '',
    illustrateDistributionsDetails: '',
  };
};



// WEBPACK FOOTER //
// ./src/components/Product/PermLifeInsurance/steps/ClientPreferences.js